// Pour ajouter un chantier : copier un bloc et remplacer titre, ville,
// prestation et les photos. Trois formats possibles :
// - `avant` + `apres` : comparateur avant/après à glisser
// - `photo` : photo unique réelle, affichée telle quelle
// - `image` : photo d'illustration (un effet visuel simule le "avant")
export const chantiers = [
  {
    id: "salon-cheminee",
    titre: "Salon — mur cheminée terracotta",
    ville: "Douzat",
    prestation: "Peinture intérieure décorative — mur d'accent",
    avant: "/chantiers/salon-avant.jpg",
    apres: "/chantiers/salon-apres.jpg",
  },
  {
    id: "facade-volets",
    titre: "Façade & volets bleu pastel",
    ville: "Douzat",
    prestation: "Peinture extérieure — façade & volets",
    avant: "/chantiers/facade-avant.jpg",
    apres: "/chantiers/facade-apres.jpg",
  },
  {
    id: "bureau-ardoise",
    titre: "Bureau — plafond refait, mur ardoise",
    ville: "Sigogne",
    prestation: "Peinture intérieure — plafond & mur d'accent",
    avant: "/chantiers/piece-avant.jpg",
    apres: "/chantiers/piece-apres.jpg",
  },
  {
    id: "portes-grange",
    titre: "Portes de grange en bois",
    ville: "Douzat",
    prestation: "Peinture extérieure — menuiseries bois",
    avant: "/chantiers/garage-avant.jpg",
    apres: "/chantiers/garage-apres.jpg",
  },
  {
    id: "volets-atelier",
    titre: "Volets refaits en atelier",
    ville: "Douzat",
    prestation: "Peinture de volets — préparation en atelier",
    photo: "/chantiers/volets-atelier.jpg",
  },
  {
    id: "volet-bois",
    titre: "Volet bois lasuré",
    ville: "Douzat",
    prestation: "Lasure & peinture bois — atelier",
    photo: "/chantiers/volet-bois.jpg",
  },
  {
    id: "wc-rose",
    titre: "WC rose poudré",
    ville: "Douzat",
    prestation: "Peinture intérieure décorative",
    photo: "/chantiers/wc-rose.jpg",
  },
];
